import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "layout-navbar"
}
const _hoisted_2 = { class: "menu-wrapper" }

import { ref, computed, watch, provide } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAppStore, useUserStore } from "@/store";
import NavBar from "@/components/navbar/index.vue";
import Menu from "@/components/menu/index.vue";
import TabBar from "@/components/tab-bar/index.vue";
import usePermission from "@/hooks/permission";
import useResponsive from "@/hooks/responsive";
import PageLayout from "./page-layout.vue";
const navbarHeight = `60px`;

export default /*@__PURE__*/_defineComponent({
  __name: 'default-layout',
  setup(__props) {

const appStore = useAppStore();
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();
const permission = usePermission();
useResponsive(true);
const navbar = computed(() => appStore.navbar);
const renderMenu = computed(() => appStore.menu);
const hideMenu = computed(() => appStore.hideMenu);
const menuWidth = computed(() => {
  return appStore.menuCollapse ? 48 : appStore.menuWidth;
});
const collapsed = computed(() => {
  return appStore.menuCollapse;
});
const paddingStyle = computed(() => {
  const paddingLeft = renderMenu.value ? { paddingLeft: `${menuWidth.value}px` } : {};
  const paddingTop = navbar.value ? { paddingTop: navbarHeight } : {};
  return { ...paddingLeft, ...paddingTop };
});
const setCollapsed = (val: boolean) => {
  appStore.updateSettings({ menuCollapse: val });
};
// watch(
//   () => userStore.roles,
//   (roleValue) => {
//     if (roleValue && !permission.accessRouter(route)) router.push({ name: "notFound" });
//   }
// );
const drawerVisible = ref(false);
const drawerCancel = () => {
  drawerVisible.value = false;
};
provide("toggleDrawerMenu", () => {
  drawerVisible.value = !drawerVisible.value;
});

return (_ctx: any,_cache: any) => {
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    class: _normalizeClass(["layout", { mobile: _unref(appStore).hideMenu }])
  }, {
    default: _withCtx(() => [
      (navbar.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(NavBar)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout, null, {
            default: _withCtx(() => [
              (renderMenu.value)
                ? (_openBlock(), _createBlock(_component_a_layout_sider, {
                    key: 0,
                    class: "layout-sider",
                    breakpoint: "xl",
                    collapsed: collapsed.value,
                    collapsible: true,
                    width: menuWidth.value,
                    style: _normalizeStyle({ paddingTop: navbar.value ? '60px' : '' }),
                    "hide-trigger": true,
                    onCollapse: setCollapsed
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(Menu)
                      ])
                    ]),
                    _: 1
                  }, 8, ["collapsed", "width", "style"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_layout, {
                class: "layout-content",
                style: _normalizeStyle(paddingStyle.value)
              }, {
                default: _withCtx(() => [
                  (_unref(appStore).tabBar)
                    ? (_openBlock(), _createBlock(TabBar, { key: 0 }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_layout_content, null, {
                    default: _withCtx(() => [
                      _createVNode(PageLayout)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})